import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/getting-started"
        }}>{`Getting Started`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "/getting-started/gatsby"
            }}>{`Getting Started with Gatsby`}</a></li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/theming"
        }}>{`Theming`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/sx-prop"
        }}>{`The `}<inlineCode parentName="a">{`sx`}</inlineCode>{` Prop`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/styling-mdx"
        }}>{`Styling MDX`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/color-modes"
        }}>{`Color Modes`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/themed"
        }}>{`Themed`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/mdx-components"
        }}>{`MDX Components`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/hooks"
        }}>{`Hooks`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/api"
        }}>{`API`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/theme-spec"
        }}>{`Theme Specification`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/customize"
        }}>{`Customize`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/demo"
        }}>{`Demo`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/resources"
        }}>{`Resources`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components"
        }}>{`Components`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/variants"
            }}>{`Variants`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/box"
            }}>{`Box`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/flex"
            }}>{`Flex`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/grid"
            }}>{`Grid`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/button"
            }}>{`Button`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/text"
            }}>{`Text`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/heading"
            }}>{`Heading`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/link"
            }}>{`Link`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/paragraph"
            }}>{`Paragraph`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/image"
            }}>{`Image`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/card"
            }}>{`Card`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/forms"
            }}>{`Forms`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/label"
            }}>{`Label`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/input"
            }}>{`Input`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/select"
            }}>{`Select`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/textarea"
            }}>{`Textarea`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/radio"
            }}>{`Radio`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/checkbox"
            }}>{`Checkbox`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/switch"
            }}>{`Switch`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/slider"
            }}>{`Slider`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/field"
            }}>{`Field`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/progress"
            }}>{`Progress`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/donut"
            }}>{`Donut`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/spinner"
            }}>{`Spinner`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/avatar"
            }}>{`Avatar`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/badge"
            }}>{`Badge`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/close"
            }}>{`Close`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/alert"
            }}>{`Alert`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/divider"
            }}>{`Divider`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/embed"
            }}>{`Embed`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/aspect-ratio"
            }}>{`AspectRatio`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/aspect-image"
            }}>{`AspectImage`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/container"
            }}>{`Container`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/nav-link"
            }}>{`NavLink`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/message"
            }}>{`Message`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/icon-button"
            }}>{`IconButton`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/components/menu-button"
            }}>{`MenuButton`}</a></li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/packages"
        }}>{`Packages`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "/packages/css"
            }}>{`@theme-ui/css`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/packages/core"
            }}>{`@theme-ui/core`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/packages/components"
            }}>{`@theme-ui/components`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/packages/mdx"
            }}>{`@theme-ui/mdx`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/packages/presets"
            }}>{`@theme-ui/presets`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/packages/prism"
            }}>{`@theme-ui/prism`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/packages/color"
            }}>{`@theme-ui/color`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/packages/style-guide"
            }}>{`@theme-ui/style-guide`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/packages/editor"
            }}>{`@theme-ui/editor`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/packages/gatsby-plugin"
            }}>{`gatsby-plugin-theme-ui`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/packages/gatsby-theme-style-guide"
            }}>{`gatsby-theme-style-guide`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/packages/typography"
            }}>{`@theme-ui/typography`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/packages/match-media"
            }}>{`@theme-ui/match-media`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/packages/sidenav"
            }}>{`@theme-ui/sidenav`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/packages/tachyons"
            }}>{`@theme-ui/tachyons`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/packages/tailwind"
            }}>{`@theme-ui/tailwind`}</a></li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/guides"
        }}>{`Guides`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "/guides/how-it-works"
            }}>{`How it Works`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/guides/jsx-pragma"
            }}>{`JSX Pragma`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/guides/motivation"
            }}>{`Motivation`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/guides/object-styles"
            }}>{`Object Styles`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/guides/variants"
            }}>{`Variants`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/guides/layouts"
            }}>{`Layouts`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/guides/keyframes"
            }}>{`Keyframes`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/guides/styled-components"
            }}>{`Styled Components`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/guides/mdx-layout-components"
            }}>{`MDX Layout Components`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/guides/responsive-typography"
            }}>{`Responsive Typography`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/guides/nested-theme-providers"
            }}>{`Nested ThemeProviders`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/guides/custom-cache-provider"
            }}>{`Custom CacheProvider`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/guides/syntax-highlighting"
            }}>{`Syntax Highlighting`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/guides/theme-color-meta-tag"
            }}>{`Theme Color Meta Tag`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/guides/color-mode-toggles"
            }}>{`Color Mode Toggles`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/guides/global-styles"
            }}>{`Global Styles`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/guides/linked-headings"
            }}>{`Linked Headings`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/guides/using-theme-ui-without-mdx"
            }}>{`Using without MDX`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/guides/merging-themes"
            }}>{`Merging Themes`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/guides/typescript"
            }}>{`TypeScript`}</a></li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/recipes"
        }}>{`Recipes`}</a>
        <ul parentName="li">
          <li parentName="ul"><a parentName="li" {...{
              "href": "/recipes/gatsby-link"
            }}>{`Gatsby Link`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/recipes/flexbox-layout"
            }}>{`Flexbox Layout`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/recipes/css-grid"
            }}>{`CSS Grid`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/recipes/centered-container"
            }}>{`Centered Container`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/recipes/tiled-layout"
            }}>{`Tiled Layout`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/recipes/stack"
            }}>{`Stack Layout`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/recipes/flexbox-sidebar"
            }}>{`Flexbox sidebar`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/recipes/button"
            }}>{`Button`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/recipes/header-a1"
            }}>{`Header A1`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/recipes/header-a2"
            }}>{`Header A2`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/recipes/header-a3"
            }}>{`Header A3`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/recipes/header-a4"
            }}>{`Header A4`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/recipes/header-a5"
            }}>{`Header A5`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/recipes/footer-a1"
            }}>{`Footer A1`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/recipes/footer-a2"
            }}>{`Footer A2`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/recipes/footer-a3"
            }}>{`Footer A3`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/recipes/footer-a4"
            }}>{`Footer A4`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/recipes/post-list-a1"
            }}>{`PostList A1`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/recipes/post-list-a2"
            }}>{`PostList A2`}</a></li>
          <li parentName="ul"><a parentName="li" {...{
              "href": "/recipes/mdx-table-align"
            }}>{`MDX Table Align`}</a></li>
        </ul>
      </li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/migrating"
        }}>{`Migrating`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://github.com/system-ui/theme-ui"
        }}>{`GitHub`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      